/*
 * Tracking Event Admin - Subscriptions Management - Add State Event Subscriptions Dialog
 *
 *
 * Exports Controller: StateEventSubscriptionsEditorDialogController
 *
 */

import Assert from "tbAssert";
import MessageQueue from "../../models/MessageQueue";

import AllStatesServiceModule from "../../services/AllStatesService";
import SubscriptionEditorError from "tbClient/views/trackerbase-admin/SubscriptionEditorError";

const messageQueueType = "danger";

const mScopeSvc = new WeakMap();
const mSanitizeSvc = new WeakMap();
const mModalInstance = new WeakMap();
const mAllStatesSvc = new WeakMap();

const mErrorMessageQueue = new WeakMap();
const mStateEventSubsToAdd = new WeakMap();
const mStateEventDataSource = new WeakMap();
const mStateEventDataIsReady = new WeakMap();

const mAddStateEventSubsSelectorOptions = new WeakMap();

class StateEventSubscriptionsEditorDialogController {
    constructor($scope, $sanitize, $uibModalInstance, AllStatesService) {
        Assert.StrictAssert($scope != null, "Assertion Failure: Missing Scope Service Dependency");
        Assert.StrictAssert($sanitize != null, "Assertion Failure: Missing Sanitize Service Dependency");
        Assert.StrictAssert($uibModalInstance != null, "Assertion Failure: Missing Modal Instance Dependency");
        Assert.StrictAssert(AllStatesService != null, "Assertion Failure: Missing All States Service Dependency");

        mScopeSvc.set(this, $scope);
        mSanitizeSvc.set(this, $sanitize);
        mModalInstance.set(this, $uibModalInstance);
        mAllStatesSvc.set(this, AllStatesService);

        mErrorMessageQueue.set(this, new MessageQueue(messageQueueType));

        mStateEventSubsToAdd.set(this, []);
        mStateEventDataSource.set(this, []);
        mStateEventDataIsReady.set(this, null);

        AllStatesService
            .GetStatesAsync()
            .then(
                (allStateData) => {
                    Array.prototype.push.apply(mStateEventDataSource.get(this), allStateData);
                    mStateEventDataIsReady.set(this, true);
                },
                (errorResponse) => {
                    mErrorMessageQueue.get(this).publishMessage(errorResponse);
                    mStateEventDataIsReady.set(this, false);
                }
            );

        mAddStateEventSubsSelectorOptions.set(this, {
            dataSource: mStateEventDataSource.get(this),
            filter: "startsWith",
            delay: 500,
            dataTextField: "fullName",
            dataValueField: "stateId"
        });

    }

    get errorMessages() {
        return mErrorMessageQueue.get(this).messages;
    }

    get stateEventSubsToAdd() {
        return mStateEventSubsToAdd.get(this);
    }

    set stateEventSubsToAdd(updatedSubs) {
        mStateEventSubsToAdd.set(this, updatedSubs);
    }

    canAddStateEventSubs() {
        return (mStateEventSubsToAdd.get(this).length > 0);
    }

    get stateDataIsReady() {
        return mStateEventDataIsReady.get(this);
    }

    get addStateEventSubsSelectorOptions() {
        return mAddStateEventSubsSelectorOptions.get(this);
    }

    cancel() {
        mModalInstance.get(this).dismiss(SubscriptionEditorError.MakeEditorCancelledResult());
    }

    ok() {
        let selectedStates = this.stateEventSubsToAdd.map((st) => st.stateId);

        mModalInstance.get(this).close({
            subs: { StateEvent: selectedStates },
            msgs: []
        });
    }
}

StateEventSubscriptionsEditorDialogController.$inject = [
    "$scope",
    "$sanitize",
    "$uibModalInstance",
    "AllStatesService"
];

StateEventSubscriptionsEditorDialogController.dependencies = [
    "ngAnimate",
    "ngSanitize",
    "ui.bootstrap",
    "kendo.directives",
    AllStatesServiceModule
];

StateEventSubscriptionsEditorDialogController.template = require("./StateEventSubscriptionsEditorDialog.tpl.html");

StateEventSubscriptionsEditorDialogController.controllerAs = "tbStateEventSubMgr";

export default StateEventSubscriptionsEditorDialogController;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/StateEventSubscriptionsEditorDialog.js
// module id = QUiF
// module chunks = 1